(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('EditorialSwiper', () => ({    
      cache: {},
      swiper: null,
      init() {
        this.InitSelf();
        this.InitSwiper();
      },
      InitSelf() {
        this.cache.$self = this.$el;
      },
      InitSwiper() {
        let $self = this.cache.$self;
        let sw_options = {
          draggable: true,
          slidesPerView: 1.5,
          spaceBetween: 15,
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true
          },
          breakpoints: {
            750: {
              slidesPerView: 1,
            }
          }
        };

        this.swiper = new Swiper($self, sw_options);
      }
    }));
  });
})();